import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AppConfig {
  id: string;
  subscription_enabled: boolean;
  current_model: 'bundle' | 'subscription';
  weekly_price: number;
  monthly_price: number;
  annual_price: number;
  desktop_logo_url: string | null;
  mobile_logo_url: string | null;
  created_at: string;
  updated_at: string;
}

export function useAppConfig() {
  return useQuery({
    queryKey: ['appConfig'],
    queryFn: async (): Promise<AppConfig> => {
      const { data, error } = await supabase
        .from('app_config')
        .select('*')
        .single();
      
      if (error) {
        console.error('Error fetching app config:', error);
        throw error; // Throw error instead of returning default
      }
      
      return data as AppConfig;
    },
    staleTime: 30000, // Cache for 30 seconds
    retry: 3, // Retry failed requests 3 times
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
    refetchOnWindowFocus: true,
    refetchOnReconnect: true
  });
}